import _toConsumableArray from "/builder/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { isDocNodeEmpty, cx, isString, extension, PlainExtension, ExtensionPriority } from '@remirror/core';
import { ReactComponentExtension } from '@remirror/extension-react-component';
import { ReactSsrExtension } from '@remirror/extension-react-ssr';
import { Children, cloneElement } from 'react';
import { PlaceholderExtension } from '@remirror/extension-placeholder';
import { getElementProps } from '@remirror/react-utils';
/**
 * This is identical to the placeholder extension except that it provides SSR
 * support.
 */

var ReactPlaceholderExtension = /*#__PURE__*/function (_PlaceholderExtension) {
  _inherits(ReactPlaceholderExtension, _PlaceholderExtension);

  var _super = _createSuper(ReactPlaceholderExtension);

  function ReactPlaceholderExtension() {
    _classCallCheck(this, ReactPlaceholderExtension);

    return _super.apply(this, arguments);
  }

  _createClass(ReactPlaceholderExtension, [{
    key: "name",
    get: function get() {
      // This is because of a problem with extending extensions. The name constant
      // can't be changed without a forced cast
      return 'reactPlaceholder';
    }
  }, {
    key: "createSSRTransformer",
    value: function createSSRTransformer() {
      var _this = this;

      return function (element, state) {
        var _state;

        state = (_state = state) !== null && _state !== void 0 ? _state : _this.store.getState();
        var _this$options = _this.options,
            emptyNodeClass = _this$options.emptyNodeClass,
            placeholder = _this$options.placeholder;

        var _getElementProps = getElementProps(element),
            children = _getElementProps.children;

        if (Children.count(children) > 1 || !isDocNodeEmpty(state.doc)) {
          return element;
        }

        var properties = getElementProps(children);
        return /*#__PURE__*/cloneElement(element, {}, /*#__PURE__*/cloneElement(children, {
          placeholder: placeholder,
          className: cx(isString(properties.className) && properties.className, emptyNodeClass),
          'data-placeholder': placeholder
        }));
      };
    }
  }]);

  return ReactPlaceholderExtension;
}(PlaceholderExtension);

var _dec, _class;

var DEFAULT_OPTIONS = _objectSpread(_objectSpread(_objectSpread({}, ReactSsrExtension.defaultOptions), ReactPlaceholderExtension.defaultOptions), ReactComponentExtension.defaultOptions);

var STATIC_KEYS = [].concat(_toConsumableArray(ReactSsrExtension.staticKeys), _toConsumableArray(ReactPlaceholderExtension.staticKeys), _toConsumableArray(ReactComponentExtension.staticKeys));
var ReactExtension = (_dec = extension({
  defaultOptions: DEFAULT_OPTIONS,
  staticKeys: STATIC_KEYS
}), _dec(_class = /*#__PURE__*/function (_PlainExtension) {
  _inherits(ReactExtension, _PlainExtension);

  var _super2 = _createSuper(ReactExtension);

  function ReactExtension() {
    _classCallCheck(this, ReactExtension);

    return _super2.apply(this, arguments);
  }

  _createClass(ReactExtension, [{
    key: "name",
    get: function get() {
      return 'react';
    }
  }, {
    key: "onSetOptions",
    value: function onSetOptions(props) {
      var pickChanged = props.pickChanged;
      this.getExtension(ReactPlaceholderExtension).setOptions(pickChanged(['placeholder']));
    }
  }, {
    key: "createExtensions",
    value: function createExtensions() {
      var _this$options = this.options,
          transformers = _this$options.transformers,
          emptyNodeClass = _this$options.emptyNodeClass,
          placeholder = _this$options.placeholder,
          defaultBlockNode = _this$options.defaultBlockNode,
          defaultContentNode = _this$options.defaultContentNode,
          defaultEnvironment = _this$options.defaultEnvironment,
          defaultInlineNode = _this$options.defaultInlineNode,
          nodeViewComponents = _this$options.nodeViewComponents;
      return [new ReactSsrExtension({
        transformers: transformers
      }), new ReactPlaceholderExtension({
        emptyNodeClass: emptyNodeClass,
        placeholder: placeholder,
        priority: ExtensionPriority.Medium
      }), new ReactComponentExtension({
        defaultBlockNode: defaultBlockNode,
        defaultContentNode: defaultContentNode,
        defaultEnvironment: defaultEnvironment,
        defaultInlineNode: defaultInlineNode,
        nodeViewComponents: nodeViewComponents
      })];
    }
  }]);

  return ReactExtension;
}(PlainExtension)) || _class);
export { ReactExtension, ReactPlaceholderExtension };